import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectAllLicenceList, selectCurrentLicenceId } from "../../store/licenceStore/licenceSelectors";
import HorizontalPanel from "../../components/HorizontalPanel";
import { Toolbar } from "../../app/components";
import IconButton from "@material-ui/core/IconButton";
import { AddCircleOutline } from "@material-ui/icons";
import { PERMISSIONS } from "../../store/userStore/permissions.enum";
import { CheckPermission } from "../../requests/CheckPermission";
import LicenceMenuList from "../../components/LicenceMenuList";
import { pagePathGenerator } from "../../routes/pagePathGenerator";

const LicenceList = ({ currentLocationId }) => {
  const history = useHistory();
  const licenceList = useSelector(selectAllLicenceList);
  const currentLicenceId = useSelector(selectCurrentLicenceId);

  const onLicenceNavigate = (id: number) => {
    const url = pagePathGenerator.LICENCE_PAGE({
        locationId: currentLocationId,
        licenceId: id,
      });

    history.push(url);
  }

  const onNewCreate = () => {
    onLicenceNavigate(-1);
  }

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title={"Licence list"}>
          <CheckPermission permissionName={PERMISSIONS.LICENCE_MANAGEMENT_ACTIONS} noPermissionComponent={null}>
            <IconButton
              component="span"
              color="secondary"
              size="small"
              onClick={onNewCreate}
            >
              <AddCircleOutline />
            </IconButton>
          </CheckPermission>
        </Toolbar>
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.REST_SPACE}>
        <LicenceMenuList
          licenceList={licenceList}
          currentLicenceId={currentLicenceId}
          onLicenceClick={onLicenceNavigate}
        />
      </HorizontalPanel>
    </HorizontalPanel>
  );
}

export default LicenceList;